import { useEffect, useState } from "react";

const TICKS = [100, 80, 60, 40, 20, 0];

/** Fixed right-edge score ladder. Yellow block tracks scroll progress. */
export function ScoreLadder() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max <= 0 ? 0 : Math.min(1, Math.max(0, window.scrollY / max)));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const score = progress * 100;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed top-1/2 right-6 z-40 hidden h-[52vh] -translate-y-1/2 lg:block"
    >
      <div className="relative h-full">
        <span className="absolute inset-y-0 right-0 w-px bg-line" />
        <span
          className="absolute right-0 h-1.5 w-6 bg-accent transition-[top] duration-150 ease-out"
          style={{ top: `${100 - score}%` }}
        />
        {TICKS.map((t) => {
          const active = score >= t;
          return (
            <span
              key={t}
              className={
                "num absolute right-9 -translate-y-1/2 text-right text-[10px] tracking-[0.14em] transition-colors " +
                (active ? "font-bold text-ink" : "text-ink-muted")
              }
              style={{ top: `${100 - t}%` }}
            >
              {t}
            </span>
          );
        })}
      </div>
    </div>
  );
}
